import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also send bearer token as fallback for cross-origin cookie issues
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatINR(amount) {
  if (amount == null || isNaN(amount)) return "₹0";
  return "₹" + Number(amount).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function formatApiError(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

/**
 * Turn an axios error into a clear, user-facing message.
 * Prefers the backend's `detail` field; falls back to HTTP status or network hint.
 */
export function describeAxiosError(err) {
  if (!err) return "Unknown error";
  const detail = err.response?.data?.detail;
  const formatted = formatApiError(detail);
  if (formatted) return formatted;
  if (err.response) {
    const code = err.response.status;
    if (code === 401) return "Session expired — please log in again.";
    if (code === 403) return "You don't have permission for this action.";
    if (code === 404) return "Record not found.";
    if (code === 413) return "File too large.";
    return `Server error (HTTP ${code}). Please try again.`;
  }
  // No response = network/CORS/timeout
  if (err.code === "ECONNABORTED") return "Request timed out. Please try again.";
  if (err.message && err.message !== "Network Error") return err.message;
  return "Network error — please check your connection and try again.";
}

/** Download an xlsx (or any file) from the API into a browser download. */
export async function downloadXlsx(path, filename, params) {
  const { data } = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

